import { mapOptionsFromProps, withForm } from "lib/form";
import { toQueryString } from "lib/form/querystring";
import Router from "next/router";
import React from "react";

const name = "search";

const onSubmit = (values) => {
    return Promise.resolve(Router.push(`/aanbod?${toQueryString(values)}`));
};

const withSearchForm = withForm(
    {
        name,
        onSubmit
    },
    mapOptionsFromProps
);

export const SearchForm = withSearchForm(({ children }) => <>{children}</>);

const withSearchFormForResults = withForm(
    {
        name
    },
    mapOptionsFromProps
);

export const SearchFormForResults = withSearchFormForResults(({ children }) => <>{children}</>);
